import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { status as Status } from '@bt-react/constants'

const getStatus = (state: State): Status | null => state.ui.status

export default createSelector(
  [getStatus],
  (status): boolean => {

    return (status && [
      Status.PRE_ROLL_INTERSTITIAL,
      Status.GOING_LIVE,
      Status.LIVE,
      Status.OVERRUN
    ].some(_status => _status === status)) ?? false

  })
